
import * as React from 'react';
import Button from '../../Button';
import { Modal } from '../../Modal';
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import {IShelfDivider} from '../../../infrastructure/interfaces'
import '../SeedDividerEditorModal/SeedDividerEditorModal.css';

export interface ShelfDividerCreatorProps {
    show: any;
    onClose: any;
    selectedDivider: IShelfDivider | undefined,
    onSubmit(divider: IShelfDivider, formData: FormData): void;
}

export interface ShelfDividerCreatorState {
    hasRequiredFields: boolean;
    imageFormData?: FormData;
}

export default class ShelfDividerEditorModal extends React.Component<ShelfDividerCreatorProps, ShelfDividerCreatorState> {

    constructor(props: ShelfDividerCreatorProps) {
        super(props);
        this.state = {
            imageFormData: undefined,
            hasRequiredFields: false
        };
    }

    validateInput() {
        const hasValidDivider = this.props.selectedDivider != undefined
        const hasValidImages = this.state.imageFormData != undefined
        this.setState({
            hasRequiredFields: hasValidDivider && hasValidImages
        })
    }

    closeModal() {
        this.props.onClose();
    }

    handleChange(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {
            for (var key in selectorFiles) {
                if (selectorFiles.hasOwnProperty(key) && selectorFiles[key] instanceof File) {
                    var imageFormData = new FormData();
                    imageFormData.set(ImageFileTypes.SHELF_DIVIDER, selectorFiles[key]);
                    this.setState({
                        imageFormData
                    }, () => this.validateInput());
                    break;
                }
            }
        }
    }

    render() {
        return (
            <Modal show={this.props.show}
        onClose={() => {this.closeModal();}}
    >
        <Modal.Header>
            <Modal.Title>
                <h5>
                    {'Upload Shelf Separator'}
        </h5>
        </Modal.Title>
        <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
        </Modal.Header>
        <Modal.Body>
        <div className="seedDividerInputContainer">
        <div className="seedDividerInputRow">
        <label className="seedDividerInfoLabel">
            Image (JPEG, 8.5"x11")
        </label>
        <input type="file" className="filepond" onChange={(e) => this.handleChange(e.target.files)} />
        </div>
        </div>
        </Modal.Body>
        <Modal.Footer>
        <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
        Cancel
        </Button>
        <Button
        bsClass="primary"
        disabled={!this.state.hasRequiredFields}
        onClick={() => {
            if (!!this.state.imageFormData && !!this.props.selectedDivider) {
                this.props.onSubmit(this.props.selectedDivider, this.state.imageFormData);
                this.setState({
                    imageFormData: undefined,
                    hasRequiredFields: false,
                })
            }
        }}
    >
        Upload
        </Button>
        </Modal.Footer>
        </Modal>
    );
    }
}



// WEBPACK FOOTER //
// ./src/components/Modals/ShelfDividerEditorModal/ShelfDividerEditorModal.tsx